import React from "react";

const DotLoader = () => (
  <span style={{ display: "inline-block", minWidth: 32 }}>
    <span className="dot-loader-dot">.</span>
    <span className="dot-loader-dot">.</span>
    <span className="dot-loader-dot">.</span>
    <style>{`
      .dot-loader-dot {
        animation: dot-blink 1.2s infinite both;
        font-size: 2rem;
        color: #1976d2;
        margin-right: 2px;
      }
      .dot-loader-dot:nth-child(2) {
        animation-delay: 0.2s;
      }
      .dot-loader-dot:nth-child(3) {
        animation-delay: 0.4s;
      }
      @keyframes dot-blink {
        0%, 80%, 100% { opacity: 0; }
        40% { opacity: 1; }
      }
    `}</style>
  </span>
);

export default DotLoader;
